<script setup>
import { BAccordion, BAccordionItem, BLink, BTable } from 'bootstrap-vue-next';
import { computed, ref } from 'vue';

import HackathonWinnerBadge from '~/common/components/HackathonWinnerBadge.vue';

import pastEventsRaw from './pastEvents';
import PastEventsModal from './PastEventsModal.vue';

const selectedEvent = ref(null);
const showModal = ref(false);

const pastEvents = computed(() => {
  return pastEventsRaw.map((event) => {
    const contributors = event.contributors || [];

    const computedTotals = contributors.reduce((totals, contributor) => {
      return {
        merged_with_issues: totals.merged_with_issues + (contributor.merged_with_issues || 0),
        merged_merge_requests: totals.merged_merge_requests + (contributor.merged_merge_requests || 0),
        opened_merge_requests: totals.opened_merge_requests + (contributor.opened_merge_requests || 0),
        score: totals.score + (contributor.score || 0),
      };
    }, {
      merged_with_issues: 0,
      merged_merge_requests: 0,
      opened_merge_requests: 0,
      score: 0,
    });

    const top3Winners = contributors
      .slice(0, 3)
      .map(c => c.username);

    return {
      ...event,
      totals: computedTotals,
      prizeWinnersCount: contributors.filter(c => c.score > 0).length,
      totalParticipants: contributors.length,
      mergedMRs: computedTotals.merged_merge_requests,
      mergedWithIssues: computedTotals.merged_with_issues,
      openedMRs: computedTotals.opened_merge_requests,
      mergeRate: computedTotals.opened_merge_requests
        ? ((computedTotals.merged_merge_requests / computedTotals.opened_merge_requests) * 100).toFixed(2)
        : '0.00',
      winners: top3Winners,
    };
  });
});

const fields = [
  { key: 'title', label: 'Event' },
  { key: 'participation', label: 'Participation' },
  { key: 'winners', label: 'Winners' },
];

const loadEventDetails = async (event) => {
  selectedEvent.value = event.item;
  showModal.value = true;
};

const formatWinners = (winners) => {
  return winners.map((winner, rank) => ({
    rank: rank + 1,
    username: winner,
  }));
};
</script>

<template>
  <BAccordion
    class="accordion-table mb-2 mt-2"
  >
    <BAccordionItem
      title="Past events"
      :visible="true"
    >
      <BTable
        :items="pastEvents"
        :fields="fields"
        hover
        responsive
        class="mt-2"
        tbody-tr-class="cursor-pointer"
        @row-clicked="loadEventDetails"
      >
        <template #cell(participation)="{ item }">
          {{ item.prizeWinnersCount }} prize winners
          <div class="text-muted small">{{ item.mergedMRs }} merged merge requests</div>
        </template>

        <template #cell(winners)="{ value }">
          <div
            v-for="winner in formatWinners(value)"
            :key="winner.username"
          >
            <HackathonWinnerBadge
              v-if="winner.rank <= 3"
              :prize="winner.rank"
              :height="20"
              :width="20"
            />
            <BLink
              :to="{
                name: 'user',
                params: { userHandle: winner.username },
              }"
              class="text-decoration-none ms-1"
            >
              {{ winner.username }}
            </BLink>
          </div>
        </template>
      </BTable>

      <PastEventsModal
        v-model="showModal"
        :event="selectedEvent"
      />
    </BAccordionItem>
  </BAccordion>
</template>
